/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Discriminator for the promotion target type.
 */
export enum ImagePromotionTargetType {
  ImagePromotionTargetTypeNewCatalogItem = 'NewCatalogItem',
  ImagePromotionTargetTypeExistingCatalogItem = 'ExistingCatalogItem',
}
